import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=d2c63de2&scoped=true&lang=pug"
import script from "./aside.vue?vue&type=script&lang=js"
export * from "./aside.vue?vue&type=script&lang=js"
import style0 from "./aside.vue?vue&type=style&index=0&id=d2c63de2&prod&scoped=true&lang=css"
import style1 from "./aside.vue?vue&type=style&index=1&id=d2c63de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c63de2",
  null
  
)

export default component.exports